import { createDefaultDispatcher34z5li45gie67 as createDefaultDispatcher } from './CoroutineContext.mjs';
import { Unconfined_getInstance6pooz906dfij as Unconfined_getInstance } from './Unconfined.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { MainCoroutineDispatcher158x49bd8e9gp as MainCoroutineDispatcher } from './MainCoroutineDispatcher.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DispatchersClass;
function Dispatchers() {
  if (DispatchersClass === VOID) {
    class $ {
      constructor() {
        Dispatchers_instance = this;
        this.vac_1 = createDefaultDispatcher();
        this.wac_1 = Unconfined_getInstance();
        this.xac_1 = new (JsMainDispatcher())(this.vac_1, false);
        this.yac_1 = null;
      }
      zac() {
        var tmp0_elvis_lhs = this.yac_1;
        return tmp0_elvis_lhs == null ? this.xac_1 : tmp0_elvis_lhs;
      }
    }
    initMetadataForObject($, 'Dispatchers');
    DispatchersClass = $;
  }
  return DispatchersClass;
}
var Dispatchers_instance;
function Dispatchers_getInstance() {
  if (Dispatchers_instance === VOID)
    new (Dispatchers())();
  return Dispatchers_instance;
}
var JsMainDispatcherClass;
function JsMainDispatcher() {
  if (JsMainDispatcherClass === VOID) {
    class $ extends MainCoroutineDispatcher() {
      constructor(delegate, invokeImmediately) {
        super();
        this.vag_1 = delegate;
        this.wag_1 = invokeImmediately;
        this.xag_1 = this.wag_1 ? this : new (JsMainDispatcher())(this.vag_1, true);
      }
      tac() {
        return this.xag_1;
      }
      qa8(context) {
        return !this.wag_1;
      }
      ra8(context, block) {
        return this.vag_1.ra8(context, block);
      }
      toString() {
        var tmp0_elvis_lhs = this.uac();
        return tmp0_elvis_lhs == null ? this.vag_1.toString() : tmp0_elvis_lhs;
      }
    }
    initMetadataForClass($, 'JsMainDispatcher');
    JsMainDispatcherClass = $;
  }
  return JsMainDispatcherClass;
}
//region block: exports
export {
  Dispatchers_getInstance as Dispatchers_getInstanceitgtkvqfcnx3,
};
//endregion

//# sourceMappingURL=Dispatchers.mjs.map
